import { useState } from "react";
import { useMutation } from "react-query";
import { cleanObject } from "../../../helpers";
import { getEODPayment } from "../../../services/transaction";
import { salesEndOfDayView } from "../../../services/sales-point";

const useStockHistoryStatement = () => {
  const [isPayment, setIsPayment] = useState(false);
  const [endOfDayDetails, setEndOfDayDetails] = useState(null);
  const [endOfDayFormDetails, setEndOfDayFormDetails] = useState({
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    stores: [],
    initiators: [],
    order_source: "",
    payment_method: [],
    sub_account: "",
  });

  const getFormatedEndOfDay = () => {
    return cleanObject({
      store_id: endOfDayFormDetails?.stores
        .map((item) => item?.value)
        ?.join("|"),
      start_date: endOfDayFormDetails?.startDate,
      end_date: endOfDayFormDetails?.endDate,
      start_time: endOfDayFormDetails?.startTime,
      end_time: endOfDayFormDetails?.endTime,
      initiator_id: endOfDayFormDetails?.initiators?.some(
        (item) => item?.value === "select all",
      )
        ? []
        : endOfDayFormDetails?.initiators?.length > 0
          ? endOfDayFormDetails?.initiators
              ?.map((item) => item?.value)
              ?.join("|")
          : null,
      order_source: endOfDayFormDetails?.order_source?.value,
    });
  };

  const { isLoading: isGeneratingDetails, mutate: getEndOfDayView } =
    useMutation((data) => salesEndOfDayView(data));
  const getEndOfDayDetails = () => {
    getEndOfDayView(getFormatedEndOfDay(), {
      onSuccess: (res) => {
        setEndOfDayDetails(res?.data?.data);
      },
    });
  };

  const { isLoading: isFetchingTnx, mutate: getEODPaymentView } = useMutation(
    (data) => getEODPayment(data),
  );
  const getPaymentEndOfDayDetails = () => {
    getEODPaymentView(
      cleanObject({
        payment_method: endOfDayFormDetails?.payment_method
          .map((item) => item?.value)
          ?.join("|"),
        sub_account_id: endOfDayFormDetails?.sub_account,
        start_date: endOfDayFormDetails?.startDate,
        end_date: endOfDayFormDetails?.endDate,
      }),
      {
        onSuccess: (res) => {
          setEndOfDayDetails(res?.data?.data);
          setIsPayment(true);
        },
      },
    );
  };

  return {
    endOfDayDetails,
    endOfDayFormDetails,
    isFetchingTnx,
    isPayment,
    isProcessing: isFetchingTnx || isGeneratingDetails,
    getFormatedEndOfDay,
    getEndOfDayDetails,
    setEndOfDayFormDetails,
    setEndOfDayDetails,
    setIsPayment,
    getPaymentEndOfDayDetails,
  };
};
export default useStockHistoryStatement;
